import React from 'react';
import { Col } from 'reactstrap';
import CardLabel from '../elements/cardLabel';
import Image from '../../../elements/image';

//TODO - Allow type to change with change in number of images per row.
const SquareCard = ({
	size, className, initialText, hoverText, heading, image, link, clickHandler, position, show,
}) => (
	position < 4 || show ? <Col className={className}>
		<a href={link} onClick={clickHandler} className="no-underline" style={{ color: '#444' }}>
			<div className="card card-inner">
				<Image src={image} className="w-100" alt={heading} type="four-col" />
				<div className="label-box">
					<CardLabel text={heading} className="heading" />
					<CardLabel text={initialText} className="subheading" />
					<CardLabel text={hoverText} className="subheading hover" />
				</div>
			</div>
		</a>
	</Col>
		:
		null
);

SquareCard.defaultProps = {
	size: {
		xl: '2',
		lg: '3',
		md: '3',
		sm: '12',
	},
	className: 'gi-cause-card d-flex stack-5 mobile-ls-w-50 ',
	heading: 'health',
	initialText: '50 programs',
	hoverText: '1230 supporters',
	image: '/static/square-placeholder.jpg',
};

export default SquareCard;
